export default __webpack_public_path__ + "static/media/b4.a6d151d1.jpg";